// Removes case, space and accent differences before comparing, so "N37E3"
// finds "N37 E300" and "Beal" finds "Béal". Decomposes accented letters (NFD)
// and drops the combining marks - a code-point range rather than \p{M}, which
// needs a newer regex engine.
function normalize(text) {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '')
}

// Does optionLabel match query, using the given mode?
function isMatch(optionLabel, query, mode) {
  const normalizedQuery = normalize(query)
  if (!normalizedQuery) {
    return false
  }
  const normalizedOption = normalize(optionLabel)
  return mode === 'contains'
    ? normalizedOption.includes(normalizedQuery)
    : normalizedOption.startsWith(normalizedQuery)
}

// Filters options against a query, respecting the minimum character threshold.
// options: Array<{ id: string, label: string }>
// mode: 'start' | 'contains'
function filterOptions({ options, query, mode, minChars }) {
  // Counts the characters that will actually be matched, so internal spaces
  // ("a b") don't count towards the threshold.
  if (normalize(query).length < minChars) {
    return { status: 'belowThreshold', matches: [], matchCount: 0 }
  }

  const matches = options.filter((option) => isMatch(option.label, query, mode))

  return {
    status: matches.length > 0 ? 'hasMatches' : 'noMatches',
    matches,
    matchCount: matches.length
  }
}

module.exports = { normalize, isMatch, filterOptions }
